import { CartesianGrid, Line, LineChart, XAxis, YAxis } from 'recharts';
import { ChartContainer, ChartTooltip, ChartTooltipContent, ChartConfig } from '@/components/ui/chart';
import { generateTicks } from '@/helpers';
import { Logo } from '@/components';

interface PriceTrendChartCanvasProps {
  readonly data: {
    quarter: string;
    maxRange: number;
    averagePrice: number;
    minRange: number;
  }[];
  readonly interval?: number;
  readonly minYAxis?: number;
  readonly maxYAxis?: number;
}

const chartConfig: ChartConfig = {
  maxRange: {
    label: 'Max',
    color: 'hsl(142, 76%, 36%)',
  },
  averagePrice: {
    label: 'Average',
    color: 'hsl(25, 95%, 53%)',
  },
  minRange: {
    label: 'Min',
    color: 'hsl(0, 0%, 20%)',
  },
};

export function PriceTrendChartCanvas({ data, interval, minYAxis, maxYAxis }: PriceTrendChartCanvasProps) {
  const yTicks = generateTicks(minYAxis, maxYAxis, interval);

  return (
    <div className="relative w-full min-w-0">
      <Logo
        color="brand"
        className="pointer-events-none absolute left-1/2 z-0 h-[100px] w-auto -translate-x-1/2 translate-y-1/2 opacity-7"
      />
      <ChartContainer config={chartConfig} className="aspect-[2/1] w-full md:aspect-auto md:h-[280px]">
        <LineChart data={data} margin={{ left: 0, right: 20, top: 20, bottom: 20 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis dataKey="quarter" tickLine={false} axisLine={false} tickMargin={20} className="text-sm" />
          <YAxis
            domain={typeof minYAxis === 'number' && typeof maxYAxis === 'number' ? [minYAxis, maxYAxis] : undefined}
            ticks={yTicks}
            tickLine={false}
            axisLine={false}
            tickMargin={0}
            tickFormatter={(value) => `${value.toLocaleString('es-ES')}`}
            className="text-sm"
            width={70}
          />
          <ChartTooltip cursor={false} content={<ChartTooltipContent />} />
          <Line dataKey="maxRange" type="monotone" stroke="var(--color-maxRange)" strokeWidth={2} dot={false} />
          <Line
            dataKey="averagePrice"
            type="monotone"
            stroke="var(--color-averagePrice)"
            strokeWidth={1}
            dot={false}
            strokeDasharray="5 5"
          />
          <Line dataKey="minRange" type="monotone" stroke="var(--color-minRange)" strokeWidth={2} dot={false} />
        </LineChart>
      </ChartContainer>
    </div>
  );
}
